import React, {Component} from 'react'
import PrintPreview from './PrintPreview'
import HrStore from '../../stores/HrStore'

const DEFAULT_ITEM_PER_PAGE = 15
const localStorageKey = 'kkc.print-report-contractor-wage-slip'
class PrintReportContractorWageSlip extends Component {

  constructor(...args){
    super(...args)
    this.state = {report_title:'กำลังดึงข้อมูล..',loading:false,data:[],itemPerPage:DEFAULT_ITEM_PER_PAGE,allData:{dataList:[]},rowAuto: JSON.parse(localStorage.getItem(localStorageKey)) || {row:'30'}}

    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('landscape');
  }

  componentDidMount(){

    if (JSON.parse(localStorage.getItem(localStorageKey))==null) {
      let rowAuto = {row:'30'}
      localStorage.setItem(localStorageKey, JSON.stringify(rowAuto))
      this.setState({rowAuto:rowAuto})
    }


    // this.loadContractorSlipDetailAll(this.state.itemPerPage)    

    this.setState({loading:true})
    HrStore.loadContractorSlipDetailAll(this.props.slipList,(result) => {
      let allData = {dataList:[]}
      allData.dataList = this.getRootData(result.data,this.state.itemPerPage)
      this.setState({data:result.data,loading:false,allData:allData,report_title:'ไม่พบข้อมูล'})
    })
  }

  loadContractorSlipDetailAll(itemPerPage) {
    // this.setState({loading:true})
    // HrStore.loadContractorSlipDetailAll(this.props.slipList,(result) => {
    //   let allData = {dataList:[]}
    //   allData.dataList = this.getRootData(result.data,itemPerPage)
    //   this.setState({data:result.data,loading:false,allData:allData,report_title:'ไม่พบข้อมูล'})
    // })  

    let allData = {dataList:[]}
    allData.dataList = this.getRootData(this.state.data,itemPerPage)
    this.setState({loading:false,allData:allData,report_title:'ไม่พบข้อมูล'})
  }

  addNewLine(val){
    let valLine = val.split('\\n')
    return valLine.map(function(item, key) {
      return (
        <span key={key}>
          {item}
          {key==valLine.length-1?'':<br/>}
        </span>
      )
    })
  }

  addLineBreak(vals) {
    const divStyle = {
      whiteSpace: 'pre-line'
    }
    return(
      vals.map((item,index)=>{
        return(
          <div key={index} style={divStyle}>
            {item.detail}
          </div>
        )
      })
    )
  }

  getNumberFormat(number) {
    if (number==''||isNaN(number)) {
      return '0.00'
    } else {
      return parseInt(number).toLocaleString(undefined, {minimumFractionDigits: 2})
    }  
  }

  getBalanceRow(income,withdraw) {
    if (income==''||income==null||income==undefined||isNaN(income)) {
      income = 0
    }
    if (withdraw==''||withdraw==null||withdraw==undefined||isNaN(withdraw)) {
      withdraw = 0
    }
    return income - withdraw
  }

  renderImg(datas,root) {
    let {data} = this.state
    if (datas.length==0) {
      return('')
    } else {
      return(
        datas.map((items,indexs)=>{
          if (items.isImg) {
            return(
              data[root].info.slip_detail.income[items.index].images.map((item,index)=>{
                if (index<3) {
                  return(
                    <img className='img-wgae-slip' key={index} src={item.thumbnailUrl} style={{maxWidth:'140px',maxHeight:'80px'}} />
                  )
                }
              })
            )      
          }      
        })
      )
    }  
  }

  renderImgRowPerPage(datas) {
    if (datas.length==0) {
      return('')
    } else {
      return(
        datas.map((item,index)=>{
          if (index<3) {
            return(
              <img className='img-wgae-slip' key={index} src={item.thumbnailUrl} style={{maxWidth:'140px',maxHeight:'80px'}} />
            )
          }      
        })
      )
    }
  }

  renderRowData(items,indexs,slipIndex) {
    let {data} = this.state
    if (items.data==undefined||items.data.length==0) {
      return(<tr><td colSpan={8}>ไม่พบข้อมูล</td></tr>)
    } else {
      return(
        items.data.map((item,index) => {
          return(
            <tr key={index}>
              <td className='text-center font-print'>{((index>0)||(index==0&&!item.isSameIndex)?item.index+1:'')}</td>
              <td className='text-center font-print'>{((index>0)||(index==0&&!item.isSameIndex)?data[items.root].info.slip_detail.income[item.index].car_detail:'')}</td>
              <td className='text-center font-print'>{((index>0)||(index==0&&!item.isSameIndex)?data[items.root].info.slip_detail.income[item.index].car_registration_no:'')}</td>
              <td className='font-print'>
                {this.addLineBreak(item.data)}
                <div className='text-center'>
                  {this.renderImg(item.data,items.root)}
                </div>
              </td>
              <td className='text-center font-print'>{((index>0)||(index==0&&!item.isSameIndex)?data[items.root].info.slip_detail.income[item.index].owner_name:'')}</td>
              <td className='text-right font-print'>{((index>0)||(index==0&&!item.isSameIndex)?this.getNumberFormat(data[items.root].info.slip_detail.income[item.index].total_income):'')}</td>
              <td className='text-right font-print'>{((index>0)||(index==0&&!item.isSameIndex)?this.getNumberFormat(data[items.root].info.slip_detail.income[item.index].net_withdraw):'')}</td>        
              <td className='text-right font-print'>{((index>0)||(index==0&&!item.isSameIndex)?this.getNumberFormat(this.getBalanceRow(data[items.root].info.slip_detail.income[item.index].total_income,data[items.root].info.slip_detail.income[item.index].net_withdraw)):'')}</td>        
            </tr>
          )
        })
      )
    }  
  }

  renderRowDataRowPerPage(items,indexs) {
    if (items.data.length==0) {
      return(<tr><td colSpan={8}>ไม่พบข้อมูล</td></tr>)
    } else {
      return(
        items.data.map((item,index) => {
          let page = (items.page*this.state.itemPerPage)-this.state.itemPerPage
          return(
            <tr key={index}>
              <td className='text-center font-print'>{(page+index+1)*1}</td>
              <td className='text-center font-print'>{item.car_detail}</td>
              <td className='text-center font-print'>{item.car_registration_no}</td>
              <td className='font-print'>
                {this.addNewLine(item.detail)}
                <div className='text-center'>
                  {this.renderImgRowPerPage(item.images)}
                </div>
              </td>
              <td className='text-center font-print'>{item.owner_name}</td>
              <td className='text-right font-print'>{this.getNumberFormat(item.total_income)}</td>
              <td className='text-right font-print'>{this.getNumberFormat(item.net_withdraw)}</td>        
              <td className='text-right font-print'>{this.getNumberFormat(item.total_income - item.net_withdraw)}</td>        
            </tr>
          )
        })
      )
    }
  }

  renderSignature(){
      return(
          <div className='footer-page-landscape'>
            <table className='table table-print-report-contractor-wage-foot'>
              <tbody>
                <tr>
                    <td className='text-center font-print'>
                    .....................................................................<br/>
                    ชื่อผู้รับเงิน
                  </td>
                  <td className='text-center font-print'>
                    .....................................................................<br/>                    
                    ผู้มีอำนาจลงนาม
                  </td>   
                </tr>
              </tbody>
            </table>
          </div>  
      )
  }

  renderFooter(item) {
    return(
          <tfoot>
            <tr>
              <th className='text-center font-print' colSpan={5}>รวมทั้งสิ้น</th>
              <th className='text-right font-print'>{this.getNumberFormat(item.net_income)}</th>
              <th className='text-right font-print'>{this.getNumberFormat(item.total_withdraw)}</th>
              <th className='text-right font-print'>{this.getNumberFormat(item.net_payable)}</th>
            </tr>
            <tr>
              <th className="text-center font-print"colSpan={2}>ส่วนของในเครือ</th>
              <th className="text-right bg-yellow font-print  text-black">0.00</th>
              <th className="text-center font-print">ส่วนของอู่</th>
              <th className="text-right bg-yellow font-print  text-black">{this.getNumberFormat(item.total_withdraw)}</th>
              <th className="text-center font-print"colSpan={2}>รวม</th>
              <th className="text-right bg-yellow font-print  text-black">{this.getNumberFormat(item.total_withdraw)}</th>
            </tr>
          </tfoot>
    )
  }

  renderFooterRowPerPage(item) {
    return(
          <tfoot>
            <tr>
              <th className='text-center font-print' colSpan={5}>รวมทั้งสิ้น</th>
              <th className='text-right font-print'>{this.getNumberFormat(item.info.slip_detail.summary.net_income)}</th>
              <th className='text-right font-print'>{this.getNumberFormat(item.info.slip_detail.summary.total_withdraw)}</th>
              <th className='text-right font-print'>{this.getNumberFormat(item.info.slip_detail.summary.net_payable)}</th>
            </tr>
            <tr>
              <th className="text-center font-print"colSpan={2}>ส่วนของในเครือ</th>
              <th className="text-right bg-yellow font-print  text-black">0.00</th>
              <th className="text-center font-print">ส่วนของอู่</th>
              <th className="text-right bg-yellow font-print  text-black">{this.getNumberFormat(item.info.slip_detail.summary.total_withdraw)}</th>
              <th className="text-center font-print"colSpan={2}>รวม</th>
              <th className="text-right bg-yellow font-print  text-black">{this.getNumberFormat(item.info.slip_detail.summary.total_withdraw)}</th>
            </tr>
          </tfoot>
    )
  }

  renderComponentPage(item,index,length,slipIndex) {
    return(
      <div className='font-print' key={index}>
        <table className='table table-print-report-contractor-wage-slip'>
          <tbody>
            <tr>
              <td className='text-center font-print' colSpan={8}>{'ค่าแรงช่าง '+item.first_name+' - '+item.position+' ประจำเดือน '+this.props.week+' '+this.getTextMonth(this.props.month)+' '+this.props.year}</td>
            </tr>
            <tr>
              <td className='text-center font-print' rowSpan={2} style={{width:'10px'}}>ลำดับ</td>
              <td className='text-center font-print' rowSpan={2} style={{width:'175px'}}>ชนิดรถ</td>
              <td className='text-center font-print' rowSpan={2} style={{width:'100px'}}>ทะเบียน</td>
              <td className='text-center font-print' rowSpan={2} style={{width:'550px'}}>รายการ</td>
              <td className='text-center font-print' rowSpan={2} style={{width:'200px'}}>เจ้าของรถ</td>
              <td className='text-center font-print' rowSpan={2} style={{width:'80px'}}>ราคาเหมา</td>
              <td className='text-center font-print' colSpan={2}>จำนวนเงิน</td>                
            </tr>
            <tr>
              <td className='text-center font-print' style={{width:'80px'}}>เบิก</td>                
              <td className='text-center font-print' style={{width:'80px'}}>คงเหลือ</td>
            </tr>
            {this.renderRowData(item,index,slipIndex)}
          </tbody>
          {item.footer?this.renderFooter(item):''}
        </table>
        {item.footer?this.renderSignature(item):''}
      </div>
    )
  }  

  renderComponentRowPerPage(item,index,length) {
    return(
      <div className='font-print' key={index}>
        <table className='table table-print-report-contractor-wage-slip'>
          <tbody>
            <tr>
              <td className='text-center font-print' colSpan={8}>{'ค่าแรงช่าง '+item.info.first_name+' - '+item.info.position+' ประจำเดือน '+this.props.week+' '+this.getTextMonth(this.props.month)+' '+this.props.year}</td>
            </tr>
            <tr>
              <td className='text-center font-print' rowSpan={2} style={{width:'10px'}}>ลำดับ</td>
              <td className='text-center font-print' rowSpan={2} style={{width:'175px'}}>ชนิดรถ</td>
              <td className='text-center font-print' rowSpan={2} style={{width:'100px'}}>ทะเบียน</td>
              <td className='text-center font-print' rowSpan={2} style={{width:'550px'}}>รายการ</td>
              <td className='text-center font-print' rowSpan={2} style={{width:'200px'}}>เจ้าของรถ</td>
              <td className='text-center font-print' rowSpan={2} style={{width:'80px'}}>ราคาเหมา</td>
              <td className='text-center font-print' colSpan={2}>จำนวนเงิน</td>                
            </tr>
            <tr>
              <td className='text-center font-print' style={{width:'80px'}}>เบิก</td>                
              <td className='text-center font-print' style={{width:'80px'}}>คงเหลือ</td>
            </tr>
            {this.renderRowDataRowPerPage(item,index)}
          </tbody>
          {item.footer?this.renderFooterRowPerPage(item):''}
        </table>
        {item.footer?this.renderSignature(item):''}
      </div>
    )
  }

  getTextMonth(month) {
    let text = ''
    if (month=='01')
      text = 'มกราคม'
    else if (month=='02')
      text = 'กุมภาพันธ์'
    else if (month=='03')
      text = 'มีนาคม'
    else if (month=='04')
      text = 'เมษายน'
    else if (month=='05')
      text = 'พฤษภาคม'
    else if (month=='06')
      text = 'มิถุนายน'
    else if (month=='07')
      text = 'กรกฎาคม'
    else if (month=='08')
      text = 'สิงหาคม'
    else if (month=='09')
      text = 'กันยายน'
    else if (month=='10')
      text = 'ตุลาคม'
    else if (month=='11')
      text = 'พฤศจิกายน'
    else if (month=='12')
      text = 'ธันวาคม'
    
    return text
  }

  onRowsPerPageChange(itemPerPage) {
    let allData = {dataList:[]}
    this.setState({itemPerPage:itemPerPage,allData:allData,report_title:'กำลังดึงข้อมูล..'})
    // setTimeout(()=>{
    //   this.loadContractorSlipDetailAll(itemPerPage)
    // },100)
    this.loadContractorSlipDetailAll(itemPerPage)
  }

  getRootData(data,_itemPerPage) {
    let sumData = []
    data.forEach((items,indexs)=>{
      if (items.info.slip_detail!=undefined) {
        if (_itemPerPage=='แถวอัตโนมัติ') {
          if (sumData.length==0)
            sumData = this.getPagination(items.info,items.info.slip_detail.income,_itemPerPage)
          else
            sumData = sumData.concat(this.getPagination(items.info,items.info.slip_detail.income,_itemPerPage)) 
          
          sumData = sumData.map((item,index)=>{
            item = Object.assign({root:indexs}, item)
            return item
          })
        } else {
          if (sumData.length==0)
            sumData = this.getPagination(items.info,items.info.slip_detail.income,_itemPerPage)
          else
            sumData = sumData.concat(this.getPagination(items.info,items.info.slip_detail.income,_itemPerPage)) 
        }  
      }
    })
    
    return sumData  
  }

  getPagination(info,slip_detail,_itemPerPage) {
    let setData = [],itemPerPage = _itemPerPage
    let {rowAuto} = this.state
    if (slip_detail.length>0&&itemPerPage=='แถวอัตโนมัติ') {
      if (itemPerPage=='แถวอัตโนมัติ') {
        if (JSON.parse(localStorage.getItem(localStorageKey))==null) {
          itemPerPage = rowAuto.row
        } else {
          let _row = JSON.parse(localStorage.getItem(localStorageKey))
          itemPerPage = _row.row
        }
      }   
      
      let checkRow = 0,detail = [],newData = [],allData = [],i = 1,checkIndex = undefined
      slip_detail.forEach((item,index)=>{
        i = 1
        item.detail.split('\\n').forEach((_item,_index)=>{
          if (_item!='') { 
            if (i==item.detail.split('\\n').length-1)
              checkIndex = index
              
            detail.push({detail:_item,index:index,isImg:false})
            if (item.images.length>0&&checkIndex!=undefined)
              detail.push({detail:false,index:index,isImg:true})

            checkIndex = undefined
            i++
          }
        })
      })
      
      detail.forEach((item,index)=>{ 
        let isDup = false
        if (checkRow>=itemPerPage) {
          allData.push(newData)
          newData = []
          checkRow = 0
        }
        if (checkRow<itemPerPage) { 
          if ((item.isImg&&itemPerPage-checkRow>=5)||!item.isImg) {
            newData.push(item)
            isDup = true
          }  
        } 
        if (checkRow==itemPerPage-1||index==detail.length-1) { 
          allData.push(newData)
          newData = []
          if (item.isImg)
            checkRow = 0
          else
            checkRow = -1
        }
        if (item.isImg) {
          if (itemPerPage-checkRow>=5) {
            checkRow += 5*1
            if (newData.length==0)
              newData.push(item)

            if (index==detail.length-1&&!isDup) {
              newData = []
              newData.push(item)
              allData.push(newData)
              newData = []
            }
          } else {
            allData.push(newData)
            newData = []
            newData.push(item)
            if (checkRow>=itemPerPage)
              checkRow += 5*1
            else
              checkRow = 5 
          }  
        } else {  
          checkRow++
        }
      })
      
      let footer = false
      allData.forEach((item,index)=>{
        if (index==allData.length-1)
          footer = true

        setData.push({data: item,footer: footer,first_name: info.first_name,position: info.position,net_income: info.slip_detail.summary.net_income,total_withdraw: info.slip_detail.summary.total_withdraw,net_payable: info.slip_detail.summary.net_payable,page: (index+1)*1,total_page: allData.length})
      })

      let sameIndex = undefined
      setData.forEach((items,indexs)=>{
        let isIndex = undefined,isSameIndex = false,groupDetail = [],details = []
        if (indexs==0) {
          sameIndex = items.data[items.data.length-1].index
        } else {
          if (sameIndex==items.data[0].index)
            isSameIndex = true

          sameIndex = items.data[items.data.length-1].index
        }
        items.data.forEach((item,index)=>{
          if (index==0) {
            details.push({detail:item.detail,index:item.index,isImg:item.isImg})
            isIndex = item.index
          } else {
            if (isIndex==item.index) {
              details.push({detail:item.detail,index:item.index,isImg:item.isImg})
            } else {
              groupDetail.push({data:details,index:isIndex,isSameIndex:isSameIndex})
              details = []
              details.push({detail:item.detail,index:item.index,isImg:item.isImg})
              isIndex = item.index
            }
          }
        })
        groupDetail.push({data:details,index:isIndex,isSameIndex:isSameIndex})
        setData[indexs].data = groupDetail
      })
      return setData
    } else {
      return this.setRowPerPage(info,slip_detail,_itemPerPage)
    } 
  }

  setRowPerPage(info,slip_detail,itemPerPage) { 
    let allData = []
    let newData = []
    let checkRow = 0
    let page = 0
    if (slip_detail.length>0) {
      slip_detail.forEach((item,index)=>{
        let footer = false
        if (checkRow<itemPerPage) { 
          newData.push(item)
        } 
        if (checkRow==itemPerPage-1||index==slip_detail.length-1) { 
          if (index==slip_detail.length-1)
            footer = true
          
          page++  
          allData.push({
            data:newData,
            footer:footer,
            info:info,
            page:page,
            total_page:Math.ceil(slip_detail.length/itemPerPage)
          })
          if (index==slip_detail.length-1)
            page = 0

          newData = []
          checkRow = -1
        }
        checkRow++
      })
    }
    return allData
  }

  renderNoData() {
    return(
      <div className='font-print'>
        <header className="text-center">
          <h2>{this.state.report_title}</h2>
        </header>
      </div>
    )
  }
  
  render() {
    let {loading,data,itemPerPage,allData} = this.state
    let page = []
    allData.dataList.forEach(function(item,index) {
      page.push({page:item.page,total_page:item.total_page})
    })
    let slipIndex = 0,prevItem=null
    if (allData.dataList.length==0) {
      return(
        <PrintPreview 
          loading={loading}
          size={'landscape'} 
          leftBarTitle={'สลิปประจำวันที่ '+this.props.week+' '+this.getTextMonth(this.props.month)+' '+this.props.year}
          defaultRowPerPage={DEFAULT_ITEM_PER_PAGE}
          startRowPerPage={1}
          endRowPerPage={20}
          rowAuto={true}
          page={page}
          onRowsPerPageChange={this.onRowsPerPageChange.bind(this)}
        >
          {this.renderNoData()}
        </PrintPreview>
      )
    } else {
      if (itemPerPage=='แถวอัตโนมัติ') {
        return(
          <PrintPreview 
            loading={loading}
            size={'landscape'} 
            leftBarTitle={'สลิปประจำวันที่ '+this.props.week+' '+this.getTextMonth(this.props.month)+' '+this.props.year}
            defaultRowPerPage={DEFAULT_ITEM_PER_PAGE}
            startRowPerPage={1}
            endRowPerPage={20}
            rowAuto={true}
            page={page}
            onRowsPerPageChange={this.onRowsPerPageChange.bind(this)}
          >
            {          
              allData.dataList.map((item,index) => {
                if (prevItem!=null) {
                  if (prevItem.footer)
                    slipIndex = 0
                  else
                    slipIndex += prevItem.data.length
                }
                prevItem = item              
                return(
                  this.renderComponentPage(item,index,allData.dataList.length-1,slipIndex)
                )        
              })
            }
          </PrintPreview>
        )
      } else {
        return(
          <PrintPreview 
            loading={loading}
            size={'landscape'} 
            leftBarTitle={'สลิปประจำวันที่ '+this.props.week+' '+this.getTextMonth(this.props.month)+' '+this.props.year}
            defaultRowPerPage={DEFAULT_ITEM_PER_PAGE}
            startRowPerPage={1}
            endRowPerPage={20}
            rowAuto={true}
            page={page}
            onRowsPerPageChange={this.onRowsPerPageChange.bind(this)}
          >
            {          
              allData.dataList.map((item,index) => {
                return(
                  this.renderComponentRowPerPage(item,index,allData.dataList.length-1)
                )         
              })
            }
          </PrintPreview>
        )
      }  
    }  
  }
}

export default PrintReportContractorWageSlip;  


// WEBPACK FOOTER //
// ./src/view/print/PrintReportContractorWageSlip.js